
export interface ZodiacSign {
  name: string;
  icon: string;
  dateRange: string;
  genitiveName: string;
  slug: string;
}

export const ZODIAC_SIGNS: ZodiacSign[] = [
  { name: 'Koziorożec', icon: '♑️', dateRange: '22.12 - 19.01', genitiveName: 'Koziorożca', slug: 'koziorozec' },
  { name: 'Wodnik', icon: '♒️', dateRange: '20.01 - 18.02', genitiveName: 'Wodnika', slug: 'wodnik' },
  { name: 'Ryby', icon: '♓️', dateRange: '19.02 - 20.03', genitiveName: 'Ryb', slug: 'ryby' },
  { name: 'Baran', icon: '♈️', dateRange: '21.03 - 19.04', genitiveName: 'Barana', slug: 'baran' },
  { name: 'Byk', icon: '♉️', dateRange: '20.04 - 20.05', genitiveName: 'Byka', slug: 'byk' },
  { name: 'Bliźnięta', icon: '♊️', dateRange: '21.05 - 20.06', genitiveName: 'Bliźniąt', slug: 'bliznieta' },
  { name: 'Rak', icon: '♋️', dateRange: '21.06 - 22.07', genitiveName: 'Raka', slug: 'rak' },
  { name: 'Lew', icon: '♌️', dateRange: '23.07 - 22.08', genitiveName: 'Lwa', slug: 'lew' },
  { name: 'Panna', icon: '♍️', dateRange: '23.08 - 22.09', genitiveName: 'Panny', slug: 'panna' },
  { name: 'Waga', icon: '♎️', dateRange: '23.09 - 22.10', genitiveName: 'Wagi', slug: 'waga' },
  { name: 'Skorpion', icon: '♏️', dateRange: '23.10 - 21.11', genitiveName: 'Skorpiona', slug: 'skorpion' },
  { name: 'Strzelec', icon: '♐️', dateRange: '22.11 - 21.12', genitiveName: 'Strzelca', slug: 'strzelec' }
];

export const POLISH_MONTHS: { [key: string]: { name: string, genitive: string, slug: string } } = {
  '01': { name: 'Styczeń', genitive: 'Stycznia', slug: 'styczen' },
  '02': { name: 'Luty', genitive: 'Lutego', slug: 'luty' },
  '03': { name: 'Marzec', genitive: 'Marca', slug: 'marzec' },
  '04': { name: 'Kwiecień', genitive: 'Kwietnia', slug: 'kwiecien' },
  '05': { name: 'Maj', genitive: 'Maja', slug: 'maj' },
  '06': { name: 'Czerwiec', genitive: 'Czerwca', slug: 'czerwiec' },
  '07': { name: 'Lipiec', genitive: 'Lipca', slug: 'lipiec' },
  '08': { name: 'Sierpień', genitive: 'Sierpnia', slug: 'sierpien' },
  '09': { name: 'Wrzesień', genitive: 'Września', slug: 'wrzesien' },
  '10': { name: 'Październik', genitive: 'Października', slug: 'pazdziernik' },
  '11': { name: 'Listopad', genitive: 'Listopada', slug: 'listopad' },
  '12': { name: 'Grudzień', genitive: 'Grudnia', slug: 'grudzien' }
};

export const MONTH_SLUG_TO_NUMBER: { [key: string]: string } = Object.fromEntries(
  Object.entries(POLISH_MONTHS).map(([num, data]) => [data.slug, num])
);
